import { SVGProps } from 'react';

const OutlinedPin = ({
  width = 86,
  height = 92,
  fill = '#FF8200',
  ...otherProps
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 86 92"
    {...otherProps}>
    <path fillRule="evenodd" clipRule="evenodd" d="M37.1477 79.271L32.1459 85.8116L9.09626 52.5235C0.398011 40.9315 1.65252 21.8788 11.7724 11.7586C17.1919 6.33905 24.4014 3.34457 32.0801 3.34457C39.7579 3.34457 46.9674 6.33905 52.4042 11.7586C59.8144 19.1688 62.7082 31.7476 59.5803 43.0391C59.3294 43.9254 59.8646 44.8456 60.7515 45.0965C61.6377 45.3474 62.558 44.8122 62.8089 43.9253C66.2377 31.4966 63.0098 17.6129 54.7632 9.38366C48.6903 3.34541 40.6441 0 32.0799 0C23.4984 0 15.4522 3.34541 9.39657 9.40108C-1.81103 20.6087 -3.21586 41.7018 6.38549 54.4818L32.0112 91.4993L39.8065 81.3121C40.3751 80.576 40.2249 79.5222 39.4889 78.9703C38.7528 78.4017 37.6989 78.5352 37.1464 79.2713L37.1477 79.271ZM32.9667 20.0713C26.51 20.0713 21.2574 25.3241 21.2574 31.7806C21.2574 38.2371 26.5102 43.4899 32.9667 43.4899C39.4234 43.4899 44.6761 38.2371 44.6761 31.7806C44.6761 25.3232 39.4233 20.0713 32.9667 20.0713ZM32.9667 40.144C28.3499 40.144 24.6028 36.3968 24.6028 31.7801C24.6028 27.1634 28.3501 23.4162 32.9667 23.4162C37.5836 23.4162 41.3307 27.1634 41.3307 31.7801C41.3307 36.3968 37.5668 40.144 32.9667 40.144ZM45.7287 51.8545V92H85.8742V51.8545H45.7287ZM82.4964 88.6551H49.0407V55.1994H58.3334V70.0001H73.889V55.1994H82.4964V88.6551ZM70 55.1994H62.2222V66.1112H70V55.1994Z" fill={fill}/>
  </svg>
);

export default OutlinedPin;
